import React from 'react'
import { useCallback, useMedia, useMemo } from 'sb-hooks'
import { Form } from 'formular'
import { Modal, ModalVisibilityProps } from 'sb-modal'

import { Row, Box } from 'components/_new/layout'
import { ContentLoader } from 'components/_new/ui'

import ProductInfo from './components/ProductInfo/ProductInfo'
import Rating from './components/Rating/Rating'
import LikeTags from './components/LikeTags/LikeTags'
import Details from './components/Details/Details'

import messages from './messages'

import s from './ReviewModalView.scss'


type ReviewFormViewProps = Pick<ModalVisibilityProps, 'onClose'> & {
  product: Review.Product
  form: Form<Review.ReviewFormValues>
  likes: Review.LikeTag[]
  dislikes: Review.LikeTag[]
  isEditing: boolean
  isFetching: boolean
  isSubmitting: boolean
  onSubmit: () => void
  onRateProduct: (rating: Review.Rating) => void
}

const ReviewModalView: React.FunctionComponent<ReviewFormViewProps> = (props) => {
  const { isMobile } = useMedia()
  const {
    product, likes, dislikes, form, isEditing, isFetching, isSubmitting, onSubmit, onRateProduct, onClose,
  } = props

  const handleSubmit = useCallback((event: React.FormEvent) => {
    event.preventDefault()

    onSubmit()
  }, [ onSubmit ])

  const buttonProps = useMemo(() => ({
    type: 'button',
    rightIcon: 'rightArrowSmall' as const,
    title: isEditing ? messages.saveTitle : messages.submitTitle,
    loading: isSubmitting,
    onClick: onSubmit,
  }), [ isEditing, isSubmitting, onSubmit ])

  return (
    <Modal
      title={messages.title}
      text={messages.text}
      className={s.modal}
      primaryButton={isFetching ? null : buttonProps}
      onClose={onClose}
    >
      {
        isFetching ? (
          <ContentLoader />
        ) : (
          <form noValidate onSubmit={handleSubmit}>
            <Box mt={32}>
              {
                isMobile ? (
                  <ProductInfo product={product}>
                    <Box mt={16}>
                      <Rating field={form.fields.rating} onChange={onRateProduct} />
                    </Box>
                  </ProductInfo>
                ) : (
                  <Row justify="start">
                    <ProductInfo product={product} />
                    <Box ml={24}>
                      <Rating field={form.fields.rating} onChange={onRateProduct} />
                    </Box>
                  </Row>
                )
              }
            </Box>
            <Box mt={32}>
              <LikeTags
                likesField={form.fields.likes}
                dislikesField={form.fields.dislikes}
                likes={likes}
                dislikes={dislikes}
              />
            </Box>
            <Box mt={32}>
              <Details
                titleField={form.fields.title}
                textField={form.fields.text}
              />
            </Box>
          </form>
        )
      }
    </Modal>
  )
}


export default ReviewModalView
